// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607270334/js/" + chunkId + "." + {"44":"b0fa9ec1","225":"0e185645","481":"874e7f1e","486":"2674d805","770":"f79af1be"}[chunkId] + ".0.7942346118632313.chunk.js";
};